module.exports = __webpack_public_path__ + "static/media/belarusbank.1aa4b8b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/belarusbank.png
// module id = 314
// module chunks = 0